// Endpoints centralizados da API
// Uma única fonte de verdade para todos os endpoints

const API_VERSION = '/api/v1';

export const endpoints = {
  auth: {
    login: `${API_VERSION}/auth/login`,
    refresh: `${API_VERSION}/auth/refresh`,
    me: `${API_VERSION}/auth/me`,
    logout: `${API_VERSION}/auth/logout`,
  },
  tutorials: {
    list: `${API_VERSION}/tutorials`,
    get: (slug: string) => `${API_VERSION}/tutorials/${slug}`,
    create: `${API_VERSION}/tutorials`,
    update: (id: string) => `${API_VERSION}/tutorials/${id}`,
    delete: (id: string) => `${API_VERSION}/tutorials/${id}`,
    search: `${API_VERSION}/tutorials/search`,
    byCategory: (categorySlug: string) => `${API_VERSION}/tutorials/category/${categorySlug}`,
    byHash: (hash: string) => `${API_VERSION}/tutorials/by-hash/${hash}`,
    progress: (tutorialId: string) => `${API_VERSION}/tutorials/${tutorialId}/progress`,
    publish: (id: string) => `${API_VERSION}/tutorials/${id}/publish`,
    unpublish: (id: string) => `${API_VERSION}/tutorials/${id}/unpublish`,
  },
  steps: {
    list: (tutorialId: string) => `${API_VERSION}/tutorials/${tutorialId}/steps`,
    create: (tutorialId: string) => `${API_VERSION}/tutorials/${tutorialId}/steps`,
    update: (tutorialId: string, stepId: string) =>
      `${API_VERSION}/tutorials/${tutorialId}/steps/${stepId}`,
    delete: (tutorialId: string, stepId: string) =>
      `${API_VERSION}/tutorials/${tutorialId}/steps/${stepId}`,
    reorder: (tutorialId: string) => `${API_VERSION}/tutorials/${tutorialId}/steps/reorder`,
  },
  categories: {
    list: `${API_VERSION}/categories`,
    get: (slug: string) => `${API_VERSION}/categories/${slug}`,
    getById: (id: string) => `${API_VERSION}/categories/${id}`,
    getChildren: (id: string) => `${API_VERSION}/categories/${id}/children`,
    create: `${API_VERSION}/categories`,
    update: (id: string) => `${API_VERSION}/categories/${id}`,
    delete: (id: string) => `${API_VERSION}/categories/${id}`,
  },
  users: {
    list: `${API_VERSION}/users`,
    get: (id: string) => `${API_VERSION}/users/${id}`,
    create: `${API_VERSION}/users`,
    update: (id: string) => `${API_VERSION}/users/${id}`,
    delete: (id: string) => `${API_VERSION}/users/${id}`,
    deletePermanent: (id: string) => `${API_VERSION}/users/${id}/permanent`,
    changePassword: (id: string) => `${API_VERSION}/users/${id}/password`,
  },
  media: {
    upload: `${API_VERSION}/media/upload`,
    list: `${API_VERSION}/media`,
    delete: (id: string) => `${API_VERSION}/media/${id}`,
  },
  headerMenus: {
    list: `${API_VERSION}/header-menus`,
    get: (id: string) => `${API_VERSION}/header-menus/${id}`,
    create: `${API_VERSION}/header-menus`,
    update: (id: string) => `${API_VERSION}/header-menus/${id}`,
    delete: (id: string) => `${API_VERSION}/header-menus/${id}`,
    reorder: `${API_VERSION}/header-menus/reorder`,
  },
  trainings: {
    list: `${API_VERSION}/trainings`,
    get: (id: string) => `${API_VERSION}/trainings/${id}`,
    create: `${API_VERSION}/trainings`,
    update: (id: string) => `${API_VERSION}/trainings/${id}`,
    delete: (id: string) => `${API_VERSION}/trainings/${id}`,
    byHash: (hash: string) => `${API_VERSION}/trainings/by-hash/${hash}`,
  },
  trainingVideos: {
    list: (trainingId: string) => `${API_VERSION}/trainings/${trainingId}/videos`,
    upload: (trainingId: string) => `${API_VERSION}/trainings/${trainingId}/videos`,
    delete: (trainingId: string, videoId: string) =>
      `${API_VERSION}/trainings/${trainingId}/videos/${videoId}`,
    reorder: (trainingId: string) => `${API_VERSION}/trainings/${trainingId}/videos/reorder`,
  },
  appointments: {
    list: `${API_VERSION}/appointments`,
    get: (id: string) => `${API_VERSION}/appointments/${id}`,
    create: `${API_VERSION}/appointments`,
    update: (id: string) => `${API_VERSION}/appointments/${id}`,
    delete: (id: string) => `${API_VERSION}/appointments/${id}`,
  },
  trainingConfigs: {
    list: `${API_VERSION}/training-configs`,
    get: (id: string) => `${API_VERSION}/training-configs/${id}`,
    getByType: (type: string) => `${API_VERSION}/training-configs/type/${type}`,
    create: `${API_VERSION}/training-configs`,
    update: (id: string) => `${API_VERSION}/training-configs/${id}`,
    delete: (id: string) => `${API_VERSION}/training-configs/${id}`,
  },
  availability: {
    list: `${API_VERSION}/availability`,
    get: (id: string) => `${API_VERSION}/availability/${id}`,
    availableSlots: `${API_VERSION}/availability/available-slots`,
    create: `${API_VERSION}/availability`,
    update: (id: string) => `${API_VERSION}/availability/${id}`,
    delete: (id: string) => `${API_VERSION}/availability/${id}`,
  },
  admin: {
    stats: `${API_VERSION}/admin/stats`,
  },
  search: {
    unified: `${API_VERSION}/search`,
  },
};

export default endpoints;
